var render = function () {
  var _vm$insuranceContract, _vm$insuranceContract2, _vm$leasingContract, _vm$leasingContract2, _vm$leasingContract3, _vm$fleet, _vm$report, _vm$customerContract;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceDialog.title", {
    title: _vm.report.title
  })) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceDialog.text")) + " ")]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.titleLabel'),
      "hint": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.titleHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.clearance.title,
      callback: function callback($$v) {
        _vm.$set(_vm.clearance, "title", $$v);
      },
      expression: "clearance.title"
    }
  })], 1), _c('v-col', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceDialog.requestClearance")) + " ")]), (_vm$insuranceContract = _vm.insuranceContract) !== null && _vm$insuranceContract !== void 0 && _vm$insuranceContract.companyId ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [(_vm$insuranceContract2 = _vm.insuranceContract) !== null && _vm$insuranceContract2 !== void 0 && _vm$insuranceContract2.isCompanyEntityLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image",
      "height": "133"
    }
  }) : _c('report-clearance-approval-contract-select-sheet', {
    attrs: {
      "contract": _vm.insuranceContract,
      "report": _vm.report,
      "clearance": _vm.clearance,
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.isInsuranceApproval,
      callback: function callback($$v) {
        _vm.isInsuranceApproval = $$v;
      },
      expression: "isInsuranceApproval"
    }
  })], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('m-no-content', {
    attrs: {
      "dense": "",
      "text": "Kein Versicherung",
      "min-height": "133"
    }
  })], 1), (_vm$leasingContract = _vm.leasingContract) !== null && _vm$leasingContract !== void 0 && _vm$leasingContract.companyId ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [(_vm$leasingContract2 = _vm.leasingContract) !== null && _vm$leasingContract2 !== void 0 && _vm$leasingContract2.isCompanyEntityLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image",
      "height": "133"
    }
  }) : _c('report-clearance-approval-contract-select-sheet', {
    attrs: {
      "contract": _vm.leasingContract,
      "report": _vm.report,
      "clearance": _vm.clearance,
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.isLeasingApproval,
      callback: function callback($$v) {
        _vm.isLeasingApproval = $$v;
      },
      expression: "isLeasingApproval"
    }
  })], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('m-no-content', {
    attrs: {
      "dense": "",
      "text": "Kein Leasing",
      "min-height": "133"
    }
  })], 1), _vm.report.fleetId ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [(_vm$leasingContract3 = _vm.leasingContract) !== null && _vm$leasingContract3 !== void 0 && _vm$leasingContract3.isCompanyEntityLoading || (_vm$fleet = _vm.fleet) !== null && _vm$fleet !== void 0 && _vm$fleet.isLoadingContracts || (_vm$report = _vm.report) !== null && _vm$report !== void 0 && _vm$report.isFleetLoading || (_vm$customerContract = _vm.customerContract) !== null && _vm$customerContract !== void 0 && _vm$customerContract.isClientCompaniesLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image",
      "height": "133"
    }
  }) : _vm.customerContract ? _c('report-clearance-approval-contract-select-sheet', {
    attrs: {
      "contract": _vm.customerContract,
      "report": _vm.report,
      "clearance": _vm.clearance,
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.isFleetApproval,
      callback: function callback($$v) {
        _vm.isFleetApproval = $$v;
      },
      expression: "isFleetApproval"
    }
  }) : _vm._e()], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('m-no-content', {
    attrs: {
      "dense": "",
      "text": "Kein Kundenvertrag",
      "min-height": "133"
    }
  })], 1)], 1)], 1), _vm.clearance.lineItems.length > 0 ? _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.positionLabel'),
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.clearance.lineItems[0].title,
      callback: function callback($$v) {
        _vm.$set(_vm.clearance.lineItems[0], "title", $$v);
      },
      expression: "clearance.lineItems[0].title"
    }
  })], 1) : _vm._e(), _vm.clearance.lineItems.length > 0 ? _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.amountLabel'),
      "persistent-hint": "",
      "outlined": "",
      "clearable": "",
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.clearance.lineItems[0].amount,
      callback: function callback($$v) {
        _vm.$set(_vm.clearance.lineItems[0], "amount", _vm._n($$v));
      },
      expression: "clearance.lineItems[0].amount"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('objects.repairEstimate.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "auto-select-first": "",
      "items": Object.values(_vm.CurrencyEnum),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      }),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.clearance.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.clearance, "currency", $$v);
      },
      expression: "clearance.currency"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.dateLabel'),
      "persistent-hint": "",
      "outlined": "",
      "hint": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.dateHint'),
      "clearable": "",
      "disabled": _vm.requestsLoading
    },
    model: {
      value: _vm.clearanceApproval.dueFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.clearanceApproval, "dueFormable", $$v);
      },
      expression: "clearanceApproval.dueFormable"
    }
  })], 1)], 1)], 1), _c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceDialog.seller")) + " ")]), _c('v-radio-group', {
    model: {
      value: _vm.requestAt,
      callback: function callback($$v) {
        _vm.requestAt = $$v;
      },
      expression: "requestAt"
    }
  }, [_vm.report.workshopCompanyId ? _c('company-sheet', {
    attrs: {
      "company": _vm.report.workShopCompany,
      "radioValue": _vm.workshopEnum
    }
  }) : _vm._e(), _vm.report.damageBrokerCompanyId ? _c('company-sheet', {
    staticClass: "mt-2",
    attrs: {
      "company": _vm.report.damageBrokerCompany,
      "radioValue": _vm.damageBrokerEnum
    }
  }) : _vm._e(), !_vm.report.damageBrokerCompanyId && !_vm.report.workshopCompanyId ? _c('m-no-content', {
    attrs: {
      "hint": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceDialog.noWorkshop')
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.create();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }